module.exports = __webpack_public_path__ + "img/ico-final-inspection-done.015f7173.svg";